<template lang="pug">
  .panel-white.mx-auto
    .panel-page-white
      PageHeader Proximity Search
      .row.body-1
        .col
          p
            span(v-if="results.length > 0")
              | Proximity search returned&nbsp;
              strong {{ displayResultIds }}.
            span(v-if="results.length === 0") Proximity search returned&nbsp;
            | {{ results.length }} linked purchasers found sharing activities occurring at either
            | the same store location or in locations within two miles and within one hour(s) of each other.
      .row.body-1.mx-0
        .col-md-9
        .col-md-3.px-0
          SearchBar(v-model="searchText")
      Datatable.mt-3(:columns="columns"
                      :entries="filteredResults"
                      :per-page="6"
                      :help-text="helpText"
                      :separator-columns="[3,6]"
                      :header-style="{'font-size': '0.6875rem', 'position': 'relative', 'padding-bottom': '1.6rem'}")
        template(slot-scope="props")
          tr
            td.body-3 {{ props.entry.purchaserName.firstName }} {{ props.entry.purchaserName.lastName }}
            td.body-3
              div {{ props.entry.purchaserIdNbr }}
              div {{ props.entry.purchaserIdTypeDesc }}
              div {{ props.entry.purchaserIdStatCd }}
            td.body-3 {{ props.entry.linkedPurchaserName.firstName }} {{ props.entry.linkedPurchaserName.lastName }}
            td.body-3
              | {{ props.entry.linkedPurchaserIdNbr }}
              br
              | {{ props.entry.linkedPurchaserIdTypeDesc }}
              br
              | {{ props.entry.linkedPurchaserIdStateCd }}
            td.body-3 {{ props.entry.relationLevel }}
            td.body-3 {{ props.entry.occurrenceCount }}
            td.body-3 {{ props.entry.sameStoreCount }}
            td.body-3 {{ props.entry.storesWithin_2mi }}
            td.body-3 {{ props.entry.sameSizeGrams ? 'Yes' : 'No' }}
            td.body-3 {{ props.entry.firstSeen }}
            td.body-3 {{ props.entry.lastSeen }}
</template>

<script>
import Datatable from '../components/Datatable'
import SearchBar from '../components/SearchBar'
import PageHeader from '../components/PageHeader'
import { joinArraySentence, globalError } from '../lib/utils'
import axios from '@/lib/axios'

export default {
  name: 'ProximityResult',
  data: function() {
    return {
      results: [],
      searchText: '',
      columns: [
        'Purchaser',
        'ID Number',
        'Linked Purchaser',
        'ID Number',
        'Relation Level',
        'Occurrence Count',
        'Same Store Count',
        'Stores within 2 miles',
        'Same Size/Grams',
        'First Seen',
        'Last Seen',
      ],
      helpText: [
        false,
        false,
        false,
        false,
        '1 = activity occurring between the Purchaser (ID selected) and a Linked Purchaser, 2 = activity occurring between one Linked Purchaser and another Linked Purchaser.',
        'Number of times both individuals shared activity at either the same store location or in locations within two miles and within one hour of each other.',
        'Count of activities between two individuals that happened at the same store.',
        'Count of activities between two individuals that happened at stores within 2 miles of each other.',
        'Both individuals made purchases of the same gram amounts.',
        'First time an activity in close proximity between individuals occurred.',
        'Last time an activity in close proximity between individuals occurred.',
      ],
    }
  },
  computed: {
    searchIds: function() {
      return this.$route.query.ids
    },
    resultIds: function() {
      return [
        ...new Set(
          this.results.map(
            val =>
              `${val.linkedPurchaserIdNbr}/${val.linkedPurchaserIdStateCd}/${
                val.linkedPurchaserIdTypeDesc
              }`,
          ),
        ),
      ]
    },
    displayResultIds: function() {
      return joinArraySentence(this.resultIds)
    },
    filteredResults: function() {
      let st = this.searchText.toLowerCase()
      if (!st) return this.resultsWithNames
      let results = []
      this.resultsWithNames.map(rwn => {
        let searchFields = [
          rwn.firstSeen,
          rwn.lastSeen,
          rwn.linkedPurchaserIdNbr,
          rwn.linkedPurchaserIdStateCd,
          rwn.linkedPurchaserIdTypeDesc,
          `${rwn.linkedPurchaserName.firstName} ${
            rwn.linkedPurchaserName.lastName
          }`,
          rwn.purchaserIdNbr,
          rwn.purchaserIdStateCd,
          rwn.purchaserIdTypeDesc,
          `${rwn.purchaserName.firstName} ${rwn.purchaserName.lastName}`,
          rwn.occurrenceCount,
          rwn.relationLevel,
          rwn.sameSizeGrams ? 'Yes' : 'No',
          rwn.sameStoreCount,
          rwn.storesWithin_2mi,
        ].map(f => (f ? f.toString().toLowerCase() : ''))
        if (searchFields.some(v => v.includes(st))) results.push(rwn)
      })
      return results
    },
    resultsWithNames() {
      return this.results.map(r => {
        return {
          ...r,
          purchaserName:
            r.purchaserNames.length > 0
              ? {
                  firstName: r.purchaserNames[0].firstName,
                  lastName: r.purchaserNames[0].lastName,
                  middleName: r.purchaserNames[0].middleName,
                }
              : { firstName: '', lastName: '', middleName: '' },
          linkedPurchaserName:
            r.linkedPurchaserNames.length > 0
              ? {
                  firstName: r.linkedPurchaserNames[0].firstName,
                  lastName: r.linkedPurchaserNames[0].lastName,
                  middleName: r.linkedPurchaserNames[0].middleName,
                }
              : { firstName: '', lastName: '', middleName: '' },
        }
      })
    },
  },
  methods: {
    reloadAsyncData() {
      axios()
        .get('/api/proximity_search', {
          params: { sid: this.$route.params.id },
        })
        .then(resp => (this.results = resp.data))
        .catch(err => globalError(err))
    },
  },
  watch: {
    '$route.query.ids': function() {
      this.reloadAsyncData()
    },
  },
  created: async function() {
    this.reloadAsyncData()
  },
  components: {
    Datatable,
    SearchBar,
    PageHeader,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 80%;

  @media (max-width: $bp-xl) {
    width: 100%;
  }
}
</style>
